// Import store so that actions can be called

// TODO: Refactor extenders in a way that all extenders are defined in an extenders list which is loaded and checked if an extender exists in runtime. Each extender should have a default set of methods.

export const updateValueExtender = function ({ dispatch, commit }, id, newValue) {};
